import { get, axiosErrorHandler } from 'models/shared/helpers/axiosInstance';
import { DashboardStats } from '../interfaces/dashboard.interface';

const baseDashboardPath = '/v1/dashboard';

export const fetchDashboardStats = async (): Promise<DashboardStats> => {
	try {
		const res = await get<DashboardStats>(`${baseDashboardPath}/stats`);
		return res.data;
	} catch (err) {
		throw axiosErrorHandler(err);
	}
};
